import * as SMLoggedInUserAllCodesActions from './../actions/SMloggedInUserAllCodes.actions';
import { AppState } from '../state/App.state';
import { SMLoggedInUserAllCodesModel } from '../models/SMloggedInUserDetails.model';

const initialState = {
    IMDCodesAndNamesList: [],
    DirectCodesAndNamesList: [],
}
export function SMloggedInUserAllCodesReducer(state: SMLoggedInUserAllCodesModel = initialState, action: SMLoggedInUserAllCodesActions.Actions) {

    switch (action.type) {
        case SMLoggedInUserAllCodesActions.UPDATE_SM_LOGGEDIN_USER_ALL_CODES:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

export const selectSMLoggedInUserAllCodes = (state: AppState) => state.SMloggedInUserAllCodes;
